import React from 'react'
import './src/styles/global.css'
import { ThemeProvider } from './src/contexts/ThemeContext'

// 将路径前缀注入到全局变量，供客户端使用
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    window.__PATH_PREFIX__ = process.env.GATSBY_PATH_PREFIX || ''
  }
}

// 全局包裹 ThemeProvider
export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}

